import { Category } from '../types'

export const categories: Category[] = [
  {
    id: '1',
    name: 'Mobile Accessories',
    slug: 'mobile-accessories',
    description: 'Cases, cables, chargers and more for your mobile devices',
    image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400',
    productCount: 156,
    icon: 'Smartphone',
  },
  {
    id: '2',
    name: 'Smart Watches',
    slug: 'smart-watches',
    description: 'Stay connected with the latest smartwatches',
    image: 'https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=400',
    productCount: 48,
    icon: 'Watch',
  },
  {
    id: '3',
    name: 'Earbuds',
    slug: 'earbuds',
    description: 'Wireless earbuds and headphones for every lifestyle',
    image: 'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=400',
    productCount: 89,
    icon: 'Headphones',
  },
  {
    id: '4',
    name: 'Power Banks',
    slug: 'power-banks',
    description: 'Keep your devices charged on the go',
    image: 'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400',
    productCount: 67,
    icon: 'Battery',
  },
  {
    id: '5',
    name: 'Chargers',
    slug: 'chargers',
    description: 'Fast chargers and adapters for all devices',
    image: 'https://images.unsplash.com/photo-1583863788434-e58a36330cf0?w=400',
    productCount: 112,
    icon: 'Zap',
  },
  {
    id: '6',
    name: 'Gaming Accessories',
    slug: 'gaming-accessories',
    description: 'Level up your gaming experience',
    image: 'https://images.unsplash.com/photo-1527814050087-3793815479db?w=400',
    productCount: 78,
    icon: 'Gamepad2',
  },
  {
    id: '7',
    name: 'Computer Accessories',
    slug: 'computer-accessories',
    description: 'Keyboards, mice, and peripherals',
    image: 'https://images.unsplash.com/photo-1595225476474-87563907a212?w=400',
    productCount: 94,
    icon: 'Monitor',
  },
]

export const brands = [
  {
    name: 'Apple',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
  },
  {
    name: 'Samsung',
    logo: 'https://images.unsplash.com/photo-1587817229766-65fa3f8fda04?w=100',
  },
  {
    name: 'Xiaomi',
    logo: 'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=100',
  },
  {
    name: 'Anker',
    logo: 'https://images.unsplash.com/photo-1583863788434-e58a36330cf0?w=100',
  },
  {
    name: 'JBL',
    logo: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=100',
  },
  {
    name: 'Logitech',
    logo: 'https://images.unsplash.com/photo-1527814050087-3793815479db?w=100',
  },
  {
    name: 'Razer',
    logo: 'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=100',
  },
  {
    name: 'Baseus',
    logo: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=100',
  },
]
